// utils/dateFilter.js

export const filterDataByTimeRange = (data, range) => {
  if (!data || data.length === 0) return data;
  if (range === 'All') return data;

  const sortedData = [...data].sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dateA - dateB;
  });

  const lastDate = new Date(sortedData[sortedData.length - 1].date);
  let startDate = new Date(lastDate);

  switch (range) {
    case '1D':
      startDate.setDate(lastDate.getDate() - 1);
      break;
    case '5D':
      startDate.setDate(lastDate.getDate() - 5);
      break;
    case '1M':
      startDate.setMonth(lastDate.getMonth() - 1);
      break;
    case '3M':
      startDate.setMonth(lastDate.getMonth() - 3);
      break;
    case 'YTD':
      startDate = new Date(lastDate.getFullYear(), 0, 1);
      break;
    case '1Y':
      startDate.setFullYear(lastDate.getFullYear() - 1);
      break;
    case '5Y':
      startDate.setFullYear(lastDate.getFullYear() - 5);
      break;
    default:
      return sortedData;
  }

  return sortedData.filter(item => {
    const itemDate = new Date(item.date);
    return itemDate >= startDate;
  });
};

export const filterDataByCustomRange = (data, startDateStr, endDateStr) => {
  if (!data || data.length === 0) return data;
  if (!startDateStr || !endDateStr) return data;

  const sortedData = [...data].sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dateA - dateB;
  });

  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  endDate.setDate(endDate.getDate() + 1);

  return sortedData.filter(item => {
    const itemDate = new Date(item.date);
    return itemDate >= startDate && itemDate < endDate;
  });
};